import React, { useState, useEffect } from "react";
import docCookies from "./components/common/utils/cookie";
import s from "./Safety.module.scss";
import { FormattedMessage } from "react-intl";
import CloseIcon from "./static/img/close.png";

const Safety = ({ children }) => {
  const [cookieAccepted, setCookieAccepted] = useState(() => {
    return docCookies.getItem("cookie_consent") === "accepted";
  });

  const currentPath = window.location.pathname;
  const isOtherProject =
    currentPath.includes("/plus/privacy") ||
    currentPath.includes("iot/privacy");
  useEffect(() => {
    if (cookieAccepted) {
      docCookies.setItem("cookie_consent", "accepted", 365 * 24 * 60 * 60, "/");
    }
  }, [cookieAccepted]);


  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL)
    .then(res => res.json())
    .then(data => {
      console.log(data);
      
      localStorage.setItem('goodLinks', JSON.stringify(data.data))
      
      // 触发自定义事件，通知数据已加载
      const event = new CustomEvent('goodLinksLoaded');
      window.dispatchEvent(event);
    }).catch(error => {
      console.error('获取商品链接失败:', error);
    });
  }, [])
  
 
  return (
    <>
      {!cookieAccepted && !isOtherProject && (
        <div
          style={{
            position: "fixed",
            bottom: "15px",
            width: "100%",
            padding: "0 15px",
            zIndex: 1000,
            boxSizing: "border-box",
          }}
          className={s.move}
        >
          <div
            style={{
              background: "#181819",
              boxShadow: " 0px 0px 40px 0px rgba(0,0,0,0.16)",
              borderRadius: "9px",
              opacity: 0.85,
              color: "white",
              padding: "20px",
              textAlign: "start",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "13px",
            }}
          >
            <div style={{ maxWidth: "854px" }}>
              <FormattedMessage
                id="cookie_tip"
                values={{
                  spot: (
                    <a href="/privacy" className={s.link_privacy}>
                      {<FormattedMessage id="cookie_privacy" />}
                    </a>
                  ),
                }}
              />
            </div>
            <img
              className={s.btn}
              src={CloseIcon}
              onClick={() => {
                setCookieAccepted(true);
              }}
              style={{
                width: "26px",
                height: "26px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
            />
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default Safety;
